import { Injectable } from '@angular/core';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { FormatterType } from '@services/analytics-services/core/models';

@Injectable()
export class FormattingService {
  constructor(
    private readonly currencyPipe: CurrencyPipe,
    private readonly decimalPipe: DecimalPipe,
    private readonly datePipe: DatePipe
  ) {}

  formatCurrency(
    value: number | string,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string,
    locale?: string
  ): string | null {
    return this.currencyPipe.transform(value, currencyCode, display, digitsInfo, locale);
  }

  formatNumber(value: number, digitsInfo?: string): string | null {
    return this.decimalPipe.transform(value, digitsInfo);
  }

  formatDate(value: number, format?: string): string | null {
    return this.datePipe.transform(value, format);
  }

  formatValue(value: number, formatter: FormatterType | undefined) {
    if (formatter === 'number') {
      return this.formatNumber(value);
    }

    if (formatter === 'date') {
      return this.formatDate(value);
    }

    if (formatter === 'currency') {
      return this.formatCurrency(value);
    }

    if (typeof formatter === 'function') {
      return formatter(value);
    }

    return value.toString();
  }
}
